// extracted by mini-css-extract-plugin
export var area = "nextroutecard-module--area--7d737";
export var cardLink = "nextroutecard-module--cardLink--137e0";
export var cardWrapper = "nextroutecard-module--cardWrapper--5f8e7";
export var contentSide = "nextroutecard-module--contentSide--30dbb";
export var description = "nextroutecard-module--description--3f1f1";
export var eyecatch = "nextroutecard-module--eyecatch--83801";
export var imageSide = "nextroutecard-module--imageSide--b577e";
export var label = "nextroutecard-module--label--c0f70";
export var meta = "nextroutecard-module--meta--a7fd1";
export var motoIcon = "nextroutecard-module--motoIcon--9143d";
export var slimCard = "nextroutecard-module--slimCard--c11f8";
export var slimLabelBadge = "nextroutecard-module--slimLabelBadge--f830a";
export var time = "nextroutecard-module--time--33f8c";
export var title = "nextroutecard-module--title--c856b";